import { TextInput, Icon } from '@paypalcorp/pp-react'
import styles from '../integration-builder.module.css'
import React, { FC } from 'react'
import withAnalytics from '../../../utils/withAnalytics'

type CardGeneratorLayoutProps = {
  data: Record<string, any>[]
  testid: string
}

const CardGeneratorLayout: FC<CardGeneratorLayoutProps> = ({
  data,
  testid,
}) => {
  const [copied, setCopied] = React.useState('')
  const fptiData = typeof window !== `undefined` && window.fpti
  const recordAnalytics = (fieldName: string) => {
    if (fptiData && window.PAYPAL?.analytics?.instance) {
      window.PAYPAL.analytics.instance.record({
        data: {
          component: 'devdiscoverynodeweb',
          page: 'main:developer:integration-builder',
          pgrp: 'main:developer:integration-builder',
          e: 'cl',
          event_action: `copy_field_${fieldName}`,
          event_category: testid,
          link: testid,
          ...fptiData,
        },
      })
    }
  }
  const copyToClipboard = (name: string, value: string) => {
    navigator.clipboard.writeText(value).then(() => {
      setCopied(`${name}-${value}`)
    })
    recordAnalytics(name)
  }

  return (
    <div
      data-testid={testid}
      className={styles.checkout_simulator__card_generator}
    >
      {data?.map(({ name, label, value }) => (
        <div
          className={styles.checkout_simulator__card_generator_text_wrapper}
          key={name}
        >
          <TextInput name={name} value={value} label={label} disabled />
          <div
            className={
              styles.checkout_simulator__card_generator_background_circle
            }
          >
            {copied === `${name}-${value}` ? (
              <Icon
                className={styles.integration_builder__copyIconSuccess}
                name="checkmark-background"
                color="sysColorSuccessMain"
              />
            ) : (
              <Icon
                className={styles.integration_builder__copyIcon}
                data-testid={`${testid}-${name}-icon`}
                name="copy-to-clipboard"
                color="sysColorPrimaryMain"
                onClick={() => copyToClipboard(name, value)}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export default withAnalytics(CardGeneratorLayout)
